<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Toast
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
  <h2>Customized Toast</h2>
  <div class="content__tools-wrap">
    <div class="content__row">
      <label for="type" class="content__row-label">Type</label>
      <select [(ngModel)]="type" placeholder="Type" class="c-input-group__control" id="type">
        <ng-container *ngFor="let type of typeList">
          <option [value]="type">{{ type }}</option>
        </ng-container>
      </select>
    </div>
    <div class="content__row">
      <div class="c-input-check-inline">
        <input id="hasCloseButton" class="c-input-check-inline__input" type="checkbox" name="hasCloseButton"
          [(ngModel)]="hasCloseButton">
        <label for="hasCloseButton" class="c-input-check-inline__label">Has Close Button</label>
        <input id="hasDefinedIcon" class="c-input-check-inline__input" type="checkbox" name="hasDefinedIcon"
        [(ngModel)]="hasDefinedIcon">
      <label for="hasDefinedIcon" class="c-input-check-inline__label">Has Defined Icon</label>
      <input id="hasModifiedIcon" class="c-input-check-inline__input" type="checkbox" name="hasModifiedIcon"
        [(ngModel)]="hasModifiedIcon">
      <label for="hasModifiedIcon" class="c-input-check-inline__label">Has Modified Icon</label>
      </div>
    </div>
    <div class="content__row">
      <label for="ariaLabel" class="content__row-label">Aria Label</label>
      <input id="ariaLabel" class="c-input-group__control" placeholder="Aria Label" type="text" name="ariaLabel"
        [(ngModel)]="ariaLabel">
        <label for="modifiedIcon" class="content__row-label">Modified Icon Name</label>
        <input id="modifiedIcon" class="c-input-group__control" label=" " placeholder="Modified Icon Name" type="text"
        name="modifiedIcon" [(ngModel)]="modifiedIcon">
    </div>
  </div>

  <maced-button buttonId="ToastButton" type="link" [queryParams]="{ toastId: 'toastId', isOpen: true }"
    label="Show Toast" [url]="currentUrl">
  </maced-button>
  <div class="u-mt-16">
    <maced-toast *ngIf="showToast" toastId="toastId" [message]="message" [type]="type" [ariaLabel]="ariaLabel"
      [hasCloseButton]="hasCloseButton" [modifiedIcon]="modifiedIcon" [hasDefinedIcon]="hasDefinedIcon"
      [hasModifiedIcon]="hasModifiedIcon">
      <ng-container ngProjectAs="[toastButtonContent]">
        <maced-link id="link" [links]="link"></maced-link>
      </ng-container>
    </maced-toast>
  </div>
</div>